(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["urev-button-builder"]) return;
  try {
    
(() => {
  function initialize(scope) {
    scope.querySelectorAll('[data-bundle-root]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('[data-bundle-form]');
      const inputs = [...root.querySelectorAll('[data-variant-id]')];
      const submit = root.querySelector('[data-bundle-submit]');
      const status = root.querySelector('[data-bundle-status]');
      const cartLink = root.querySelector('[data-bundle-cart]');
      const label = submit.textContent;
      let busy = false;
      let uncertain = false;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:root.dataset.currency || 'USD',currencyDisplay:'code'});
      inputs.forEach(input => { input.disabled = input.dataset.available !== 'true'; });
      root.querySelector('[data-bundle-controls]').hidden = false;
      function selection() {
        return inputs.filter(input => !input.disabled && Number(input.value) > 0).map(input => ({id:Number(input.dataset.variantId),quantity:Number(input.value),price:Number(input.dataset.price)}));
      }
      function update() {
        const items = selection();
        const count = items.reduce((sum,item) => sum + item.quantity,0);
        const total = items.reduce((sum,item) => sum + item.price * item.quantity,0);
        root.querySelector('[data-bundle-count]').textContent = count;
        root.querySelector('[data-bundle-total]').textContent = money.format(total / 100);
        submit.disabled = busy || uncertain || count === 0 || !form.checkValidity();
      }
      form.addEventListener('input',update);
      root.querySelector('.urev-bundle__intro a').addEventListener('click',() => {
        root.querySelector('.urev-bundle__designs').focus({preventScroll:true});
      });
      form.addEventListener('submit',async event => {
        event.preventDefault();
        if (busy || uncertain || !form.reportValidity()) return;
        const items = selection().map(({id,quantity}) => ({id,quantity}));
        if (!items.length) {status.textContent = root.dataset.empty; return;}
        busy = true;
        submit.disabled = true;
        submit.textContent = root.dataset.adding;
        status.textContent = '';
        try {
          const response = await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          if (!response.ok) throw new Error('cart');
          const result = await response.json();
          if (!Array.isArray(result.items) || result.items.length !== items.length) throw new Error('cart');
          window.location.assign(root.dataset.cartUrl);
        } catch (error) {
          uncertain = true;
          status.textContent = root.dataset.error;
          cartLink.hidden = false;
          cartLink.focus();
          submit.textContent = label;
          busy = false;
          update();
        }
      });
      update();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load',event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
